import { createSlice } from '@reduxjs/toolkit';

const initialState = { data: [], welcomeMessage: '' };

export const RegistrationFormDataSlice = createSlice({
  name: 'registrationFormData',
  initialState,
  reducers: {
    storeRegistrationFormData: (state, action) => {
      return { ...state, data: action.payload };
    },
    storeWelcomeMessage: (state, action) => {
      return { ...state, welcomeMessage: action.payload };
    },
    addRegistrationFormData: (state, action) => {
      // console.log(action.payload);
      let cloneData = [...state.data];
      // console.log(cloneData);
      cloneData.push(action.payload);

      return { ...state, data: cloneData };
    },
    flushRegistrationFormData: () => {
      return [];
    },
    updateRegistrationValue: (state, action) => {
      // console.log(action.payload);
      let cloneData = { ...state.data };
      // console.log(cloneData);
      /*
      let obj = clone.find((item) => item.id === action.payload.id);
      console.log(obj);
      let index = clone.indexOf(obj);
      obj.value = action.payload.value;
      clone[index] = obj;
      console.log(clone);
      return [...state];
      */
      return [...state];
    },
  },
});

export const activeRole = (state) => state;
export const { storeRegistrationFormData, storeWelcomeMessage, addRegistrationFormData, flushRegistrationFormData, updateRegistrationValue } = RegistrationFormDataSlice.actions;
export default RegistrationFormDataSlice.reducer;
